import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { appInfo } from 'app.info';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-app-version',
    template: `
        <div class="flex flex-column" [style.font-size.px]="10">
            <span tabindex="0">{{ appInfo.appVersion }}</span>
        </div>
    `
})
export class AppVersionComponent {
    appInfo = appInfo;
    buildVisible = false;

    get isProd() {
        return environment.production;
    }

    get buildTime() {
        if (!appInfo.buildTime) return 'No BuildTime Set';
        return DateTime.fromMillis(appInfo.buildTime).toFormat('dd.MM.yy (HH.mm)');
    }
}
